import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { createComment } from '../effects/createComment';
import { IGetState, TBoardId, TCardId } from '../../../../../../../../types/types';
import { IComment } from '../../../../../../../../store/model/card/types/IComment';
import { getCommentModel } from '../../../helpers/commentModelHelper';
import { trackCommentSent } from '../effects/trackCommentSent';
import * as React from 'react';
import { IDriveDoc } from '../../../../../../../../store/model/card/types/IDriveDoc';
import { addAttachments } from '../../../../../../../../rest/effects/card/attacments/addAttachments';
import Util from 'app/util/util';
import { showSnoozeBlocker } from '../../../../../../base/effects/showSnoozeBlocker';
import { getAuthUser } from '../../../../../../../../store/model/authUser/selectors/getAuthUser';
import { isTimeTracker } from '../selectors/isTimeTracker';
import { root } from '../../../../../../../../store/constants';
import { commentInit } from '../../../store/reducers/actions/commentInit';
import { getIsChatViewActive } from '../../../../../../../../store/router/selectors/getIsChatViewActive';

export const onCreate = (
    boardId: TBoardId,
    cardId: TCardId,
    event: React.KeyboardEvent<HTMLElement>,
    attachments: IDriveDoc[]
): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const { allowTimeTracker } = getAuthUser(state);

        let comment = getCommentModel(state, boardId) as IComment;
        comment.cardId = cardId;
        comment.text = Util.setAuthuser0(comment.text).trim();
        if (!allowTimeTracker && isTimeTracker(comment.text)) {
            dispatch(showSnoozeBlocker({ allow: 'allowTimeTracker' }));
            return;
        }
        const isChatView = getIsChatViewActive(state);
        if (attachments && attachments.length) {
            const attachmentsToAdd = attachments && attachments.length && attachments.filter(doc => !doc.id); // добавляем только те, которых нет на бэке
            const promise = attachmentsToAdd && attachmentsToAdd.length
                ? dispatch(addAttachments(cardId, attachments.filter(doc => !doc.id))) // добавляем только те, которых нет на бэке
                : Promise.resolve([]);
            return promise
                .then((docs: IDriveDoc[]) => {
                    const driveDocIds = [];
                    let pointer = 0; // сохраняем порядок добавления юзером
                    attachments.forEach(doc => {
                        if (doc.id) {
                            driveDocIds.push(doc.id);
                        } else {
                            const driveDoc = docs[pointer];
                            if (driveDoc) {
                                driveDocIds.push(driveDoc.id);
                                pointer += 1;
                            }
                        }
                    })
                    comment.driveDocIds = [...docs.map(doc => doc.id), ...attachments.filter(doc => doc.id).map(doc => doc.id)];
                    return dispatch(onCommentAdd(boardId, event, comment, isChatView));
                });
        } else {
            return dispatch(onCommentAdd(boardId, event, comment, isChatView));
        }
    };
};

const onCommentAdd = (
    boardId: TBoardId,
    event: React.KeyboardEvent<HTMLElement>,
    comment: IComment,
    isChat: boolean,
): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(commentInit());
        root.App.controller.cardsCommentsInfo.resetCardComment(comment.cardId);
        if (comment.text) {
            dispatch(trackCommentSent(event, isChat));
        }

        return dispatch(createComment(boardId, comment));
    };
}
